const fetchEntity = require("./fetchEntity");
const fetchAncestors = require("./fetchAncestors");

module.exports = async function fetchPageData({
	endpoint,
	bundles,
	layouts,
	configs,
	dispatch = null,
	headers = null,
	agent = null,
	ancestors = null,
	ssr = false,
	cachedLayouts = null,
}) {
	const entity = await fetchEntity({
		endpoint,
		bundles,
		dispatch,
		headers,
		agent,
		ssr,
		configs,
	});
	if (entity) {
		let includes = entity.includes ? { ...entity.includes } : {};
		let lists = entity.lists ? { ...entity.lists } : {};
		let relationships = entity.entity.relationships
			? { ...entity.entity.relationships }
			: {};
		ancestors = ancestors || (await fetchAncestors(entity.entity));
		const layout_info = layouts
			? layouts.find((l) => l.types.includes(entity.entity.type))
			: null;
		let layoutEntity = null;
		if (layout_info) {
			if (cachedLayouts && cachedLayouts[layout_info.id]) {
				layoutEntity = cachedLayouts[layout_info.id];
			} else {
				layoutEntity = await fetchEntity({
					endpoint: `node/layout/${layout_info.id}`,
					bundles,
					dispatch,
					headers,
					agent,
					ssr,
					configs,
				});
			}
		}

		/**
		 * Merge layout data with the main entity
		 */

		if (layoutEntity) {
			if (layoutEntity.includes) {
				includes = { ...includes, ...layoutEntity.includes };
			}
			if (layoutEntity.lists) {
				lists = { ...lists, ...layoutEntity.lists };
			}
			if (layoutEntity.entity.relationships) {
				const layoutRelNames = [
					"field_section_main",
					"field_section_sidebar",
					"field_section_closing",
				];
				for (const layout_field_name of layoutRelNames) {
					if (
						layoutEntity.entity.relationships[layout_field_name] &&
						Array.isArray(layoutEntity.entity.relationships[layout_field_name].data) &&
						layoutEntity.entity.relationships[layout_field_name].data.length > 0
					) {
						if (
							relationships[layout_field_name] &&
							Array.isArray(relationships[layout_field_name].data) &&
							relationships[layout_field_name].data.length > 0
						) {
							relationships[layout_field_name].data = [
								...relationships[layout_field_name].data,
								...layoutEntity.entity.relationships[layout_field_name].data,
							];
						} else {
							relationships[layout_field_name] =
								layoutEntity.entity.relationships[layout_field_name];
						}
					}
				}
			}
		}

		const restricted = entity.entity.attributes
			? !!entity.entity.attributes.field_restrict
			: false;
		const scheduled = entity.entity.attributes
			? entity.entity.attributes.field_scheduled
			: null;
		const created = entity.entity.attributes ? entity.entity.attributes.created : null;
		const title = entity.entity.attributes ? entity.entity.attributes.title : null;
		return {
			...entity.entity,
			relationships,
			ancestors,
			includes,
			lists,
			restricted,
			scheduled,
			created,
			title,
			layoutEntity,
		};
	}
	return null;
};
